// components
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface SelfReferralSentPageProps {
  onBack: () => void;
  onDone: () => void;
}

export const SelfReferralSentPage = ({
  onBack,
  onDone,
}: SelfReferralSentPageProps) => {
  return (
    <ModalPageTemplate onBack={onBack}>
      <CenterPageTemplate>
        <FloatingContent
          title='Invitation Sent'
          description='Check your personal email for a magic link to sign up'
          alert={{
            severity: 'info',
            message:
              'Your personal account will be linked to your partner account.',
          }}
          actions={[
            {
              label: 'Done',
              variant: 'primary',
              onClick: onDone,
            },
          ]}
        />
      </CenterPageTemplate>
    </ModalPageTemplate>
  );
};

SelfReferralSentPage.displayName = 'SelfReferralSentPage';
export default SelfReferralSentPage;
